export default "__VITE_ASSET__ISks_KSi__"